import * as React   from 'react';
import { useState } from 'react';
import Button from '@mui/material/Button';

import { useNavigate} from "react-router-dom"
import PanelComercios from './PanelComercios';
import Toolbar from '@mui/material/Toolbar';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import AppBar from '@mui/material/AppBar';
import { useStore } from './store/comercioStore' ;
import Terminos from './Terminos';
//
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
//

function MenuComercio() {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [openTerminos, setOpenTerminos] = useState(false);

  const open = Boolean(anchorEl);
  const navigate = useNavigate()
  const {  tipo ,asignaTipo ,asignaNom, comercioNombre} = useStore();

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
    asignaTipo(0);
    {  navigate('/login')}
  };

  const handleCloseTerminos = () => {
    setOpenTerminos(false);

  };

  const handleData = () => {
    {  navigate('/editComercio')}
  };

  const handleClickOpen = () => {
    setOpenTerminos(true);
  };

  const handleCloseT = () => {
    setOpenTerminos(false);
  };

  return (
    <div>
       <AppBar
        position="static"
        color="default"
        elevation={0}
        sx={{ borderBottom: (theme) => `1px solid ${theme.palette.divider}` }}
      >
    <Toolbar sx={{ flexWrap: 'wrap' }}>
          <Typography variant="h6" color="inherit" noWrap sx={{ flexGrow: 1 }}>
            Bienvenido: {comercioNombre}
          </Typography>
          <nav>
          <Link onClick={() => setOpenTerminos(true)}>Términos y Condiciones</Link>
          </nav>

          <Button href="" color ="secondary" variant="outlined" sx={{ my: 1, mx: 1.5 }} onClick= {handleData}>
            Mis Datos
          </Button>
          <Button href="" variant="outlined" sx={{ my: 1, mx: 1.5 }} onClick= {handleClose}>
            Salir
          </Button>

        </Toolbar>
        </AppBar>

    <PanelComercios />

    <Dialog
        open={openTerminos}
        onClose={handleCloseTerminos}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
           <Terminos />
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseTerminos} autoFocus>
            Cerrar
          </Button>
        </DialogActions>
      </Dialog>
    
    </div>
  );
}

export default MenuComercio